import React from 'react';
import Link from 'next/link';
import { Checkbox } from '../../subkit-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SubkitTerms = function SubkitTerms(_ref) {
  var recieveEmails = _ref.recieveEmails,
      acceptTerms = _ref.acceptTerms,
      onChange = _ref.onChange;
  return /*#__PURE__*/_jsxs("div", {
    className: "mb-3",
    children: [/*#__PURE__*/_jsx("div", {
      className: "mt-8",
      children: /*#__PURE__*/_jsxs(Checkbox, {
        name: "agreedToTerms",
        checked: acceptTerms,
        onChange: onChange,
        dataCy: "agreedToTerms",
        children: ["I agree to Subkit\u2019s", ' ', /*#__PURE__*/_jsx(Link, {
          href: "/terms",
          children: /*#__PURE__*/_jsx("a", {
            target: "_blank",
            className: "c-dark-green font-medium",
            children: "Terms of Service"
          })
        }), "\xA0and", ' ', /*#__PURE__*/_jsx(Link, {
          href: "/privacy",
          children: /*#__PURE__*/_jsx("a", {
            target: "_blank",
            className: "c-dark-green font-medium",
            children: "Privacy Policy"
          })
        }), "."]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "mt-3",
      children: /*#__PURE__*/_jsx(Checkbox, {
        name: "recommendationEmails",
        checked: recieveEmails,
        onChange: onChange,
        dataCy: "recommendationEmails",
        children: "I agree to receive occasional recommendation emails from Subkit."
      })
    })]
  });
};